export default __webpack_public_path__ + "static/media/Category.697f56fc.svg";